<app-header></app-header>
<router-outlet></router-outlet>

<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
<app-footer></app-footer>
